import { useRef, useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const services = [
  {
    title: "Pro Shop",
    image:
      "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758578601/service_shop_baxptd.jpg",
  },
  {
    title: "Restaurant",
    image:
      "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758596543/restaurant_service_qby66d.jpg",
  },
  {
    title: "Guest Room",
    image:
      "https://res.cloudinary.com/dxdvcplbl/image/upload/v1763890719/WhatsApp_Image_2025-11-02_at_22.36.07_1_nrhf5j.jpg",
  },
  {
    title: "Convention Hall",
    image:
      "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755116270/Screenshot_2025-08-13_231504-min_ctap5h.png",
  },
];

const Services = () => {
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const checkScrollPosition = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
    }
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const currentRef = scrollRef.current;
    currentRef?.addEventListener("scroll", checkScrollPosition);
    window.addEventListener("resize", checkScrollPosition);
    checkScrollPosition();

    return () => {
      currentRef?.removeEventListener("scroll", checkScrollPosition);
      window.removeEventListener("resize", checkScrollPosition);
    };
  }, []);

  return (
    <section className="bg-[#fffdf6] py-16 px-4 md:px-20 relative">
      <div className="max-w-7xl mx-auto relative">
        <div className="text-center mb-10">
          <h2 className="text-4xl font-bold text-black uppercase">
            Our Services
          </h2>
        </div>

        <div className="relative">
          {/* Left Arrow */}
          {showLeftArrow && (
            <button
              onClick={() => scroll("left")}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white shadow-lg rounded-full p-2 z-10 hover:bg-gray-100"
              aria-label="Scroll left"
            >
              <ChevronLeft size={24} />
            </button>
          )}

          {/* Scrollable Container */}
          <div
            ref={scrollRef}
            className="flex overflow-x-auto gap-6 pb-4 scrollbar-hide scroll-smooth"
            style={{ scrollBehavior: "smooth" }}
          >
            {services.map((service, index) => (
              <div
                key={index}
                className="flex flex-col rounded-2xl overflow-hidden shadow-lg group flex-shrink-0 w-[300px]"
              >
                <div className="h-72 w-full overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                </div>

                {/* Service Links */}
                {service.title === "Restaurant" ? (
                  <Link
                    to="/restaurant"
                    className="bg-lime-400 flex justify-between items-center p-4 font-semibold text-black text-lg hover:bg-lime-500 transition-colors duration-200"
                  >
                    <span>{service.title}</span>
                    <span className="text-xl">→</span>
                  </Link>
                ) : service.title === "Pro Shop" ? (
                  <Link
                    to="/pro-shop"
                    className="bg-lime-400 flex justify-between items-center p-4 font-semibold text-black text-lg hover:bg-lime-500 transition-colors duration-200"
                  >
                    <span>{service.title}</span>
                    <span className="text-xl">→</span>
                  </Link>
                ) : service.title === "Guest Room" ? (
                  <Link
                    to="/guest-room"
                    className="bg-lime-400 flex justify-between items-center p-4 font-semibold text-black text-lg hover:bg-lime-500 transition-colors duration-200"
                  >
                    <span>{service.title}</span>
                    <span className="text-xl">→</span>
                  </Link>
                ) : service.title === "Convention Hall" ? (
                  <Link
                    to="/convention-hall"
                    className="bg-lime-400 flex justify-between items-center p-4 font-semibold text-black text-lg hover:bg-lime-500 transition-colors duration-200"
                  >
                    <span>{service.title}</span>
                    <span className="text-xl">→</span>
                  </Link>
                ) : (
                  <div className="bg-lime-400 flex justify-between items-center p-4 font-semibold text-black text-lg">
                    <span>{service.title}</span>
                    <span className="text-xl">→</span>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Right Arrow */}
          {showRightArrow && (
            <button
              onClick={() => scroll("right")}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white shadow-lg rounded-full p-2 z-10 hover:bg-gray-100"
              aria-label="Scroll right"
            >
              <ChevronRight size={24} />
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default Services;
